import { CreditCard } from 'data/shared/CreditCard';
import { useURLParamState } from './useURLParamState';
import { usePointValues } from '../data/shared/hooks/usePointValues';

// Factor out overrides
export const useParamStatePointValues = (
  cards: CreditCard[],
  enableOverrides = false
) => {
  const [overrides, setOverrides] = useURLParamState<Record<string, number>>(
    'pointValues',
    {}
  );
  return usePointValues(cards, enableOverrides, setOverrides, overrides);
};
